import { Reveal, SectionHead } from "../motion";
import { SERVICES } from "../../content";

export function Services() {
  return (
    <section id="services" data-testid="services-section" className="mx-auto max-w-7xl px-5 pb-14 sm:px-8 sm:pb-20 lg:pb-24">
      <SectionHead
        eyebrow="Services"
        title="How I Can Help"
        intro="I work on individual projects and provide ongoing compliance support, depending on what your business needs."
      />

      <ol className="mt-10 divide-y divide-ink/10 border-t border-ink/10 sm:mt-12">
        {SERVICES.map((s, i) => (
          <Reveal as="li" key={s.title} delay={0.05 * i}>
            <article
              data-testid={`service-item-${i}`}
              className="group grid gap-2 py-6 transition-colors duration-300 sm:grid-cols-[3.5rem_1fr] sm:gap-4 sm:py-8"
            >
              <p className="font-display text-2xl italic text-gold/80 transition-colors duration-300 group-hover:text-cherry">
                {String(i + 1).padStart(2, "0")}
              </p>
              <div>
                <h3 className="font-display text-xl leading-snug text-ink sm:text-2xl">{s.title}</h3>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink/65 sm:text-base">{s.body}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </ol>
    </section>
  );
}
